import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveDisplayStatus } from '@/lib/domain';
import { labelNameForCode } from '../lib/displayLabelCode';

export interface OrderStatusPillProps {
  displayStatus: string | null | undefined;
  /**
   * BE `displayLabelCode`(OrderStatusLabel enum 상수, 고도몰 25행 카탈로그 정본). 노출 시 라벨
   * 텍스트는 이 코드의 한국어 노출이름으로 렌더한다(16차 ID51). 아이콘/색(badge)은 `displayStatus`
   * 기준 유지. 코드 미노출(레거시/미배포) 시 기존 `status.*` i18n 라벨로 graceful fallback —
   * BE 가 필드를 emit 하면 자동 활성(OpenAPI 재생성 전에도 tsc 안전).
   */
  displayLabelCode?: string | null | undefined;
  orderId?: string;
}

export const OrderStatusPill = ({
  displayStatus,
  displayLabelCode,
  orderId,
}: OrderStatusPillProps) => {
  const { t } = useTranslation('orders');
  // 아이콘/색은 displayStatus 기준(FE 도출 아님 — BE 가 내린 status 의 표현 메타).
  const meta = resolveDisplayStatus(
    displayStatus,
    orderId ? { orderId, entity: 'order' } : undefined,
  );
  // 라벨 텍스트: displayLabelCode(고도몰 노출이름 정본) 우선, 부재 시 레거시 status.* i18n.
  const label = displayLabelCode
    ? labelNameForCode(displayLabelCode, t(meta.i18nKey, displayStatus ?? ''))
    : t(meta.i18nKey, displayStatus ?? '');
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={displayStatus}
      label={label}
      testId="order-status-pill"
    />
  );
};
